// extracted by mini-css-extract-plugin
module.exports = {"Title":"statuses_Title__n_G3j","CancelReasonLabel":"statuses_CancelReasonLabel__HFk7k","CancelReason":"statuses_CancelReason__xADg7"};